import { render, staticRenderFns } from "./PxRespostaPrazoPreco.vue?vue&type=template&id=efa3fdb2&"
import script from "./PxRespostaPrazoPreco.vue?vue&type=script&lang=js&"
export * from "./PxRespostaPrazoPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports